const NETWORK_ERROR_MESSAGES = [
  'Failed to fetch',
  'Network request failed',
  'Load failed',
  'NetworkError when attempting to fetch resource',
];

export function isNetworkError(e: unknown): boolean {
  return e instanceof TypeError && (
    !e.message ||
    NETWORK_ERROR_MESSAGES.some((msg) => e.message.includes(msg))
  );
}
